var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"outline-none e2e-login secondary--text",attrs:{"type":"button","role":"button","aria-haspopup":"true","aria-expanded":"false"},on:{"click":function($event){$event.stopPropagation();return _vm.$store.commit('auth/OPEN', true)}}},[_vm._v(" Log In ")])
}
var staticRenderFns = []

export { render, staticRenderFns }